module.exports = __webpack_public_path__ + "static/media/Arrow-right-bright-red.3ca8c2b5.svg";